import classNames from 'classnames';
import React from 'react';

interface IPriceAmountProps {
  deposit?: number;
  amount?: number;
  currency?: string;
  className?: string;
}

const PriceAmount: React.FC<React.PropsWithChildren<React.PropsWithChildren<IPriceAmountProps>>> = ({
  deposit,
  amount,
  currency,
  className = '',
}) => {
  return (
    <span className={className}>
      <span
        className={classNames({
          hidden: amount || amount === 0,
        })}
      >
        {currency}
        {deposit?.toLocaleString()}
      </span>
      <span hidden={!amount && amount !== 0}>
        {' '}
        {currency}
        {amount?.toLocaleString()}
      </span>
    </span>
  );
};
export default PriceAmount;
